import { SVGProps, SVGAttributes } from 'react';

const TokenIcon = (props: SVGProps<SVGAttributes<SVGSVGElement>>) => {
    const { stroke, width, height } = props;

    return (
        <svg
            width={width || '160'}
            height={height || '130'}
            viewBox="0 0 160 130"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                opacity="0.25"
                d="M1 76H26"
                stroke={stroke || '#0F90FF'}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                opacity="0.25"
                d="M6 89H22"
                stroke={stroke || '#0F90FF'}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                opacity="0.25"
                d="M13 101H30"
                stroke={stroke || '#0F90FF'}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                opacity="0.25"
                d="M40.5 109H126C132.627 109 138 103.627 138 97V33C138 26.3726 132.627 21 126 21H34C27.3726 21 22 26.3726 22 33V67"
                stroke={stroke || '#0F90FF'}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                opacity="0.25"
                d="M30 40L74.1366 67.806C77.7196 70.0634 82.2804 70.0634 85.8634 67.806L130 40"
                stroke={stroke || '#0F90FF'}
                strokeWidth="2"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
            <path
                d="M90.3997 85.2708L83.5001 85.3521M83.5001 85.3521L83.3782 95.7014M83.5001 85.3521L74.4997 85.4942M60.3211 85.6614C60.3121 87.4306 59.9532 89.1889 59.265 90.8349C58.5767 92.4809 57.5728 93.9822 56.3111 95.2522C55.0493 96.5223 53.5545 97.5361 51.9129 98.2352C50.2713 98.9343 48.5152 99.305 46.7458 99.3259C44.9763 99.3467 43.2285 99.0174 41.6029 98.3567C39.9773 97.6961 38.5061 96.7173 37.2739 95.4766C36.0417 94.236 35.0729 92.758 34.4233 91.1277C33.7737 89.4975 33.4561 87.7472 33.4888 85.9777C33.5914 82.4596 35.0711 79.09 37.6092 76.5946C40.1473 74.0992 43.5408 72.6777 47.0587 72.6362C50.5765 72.5948 53.9374 73.9367 56.4174 76.3729C58.8973 78.8091 60.298 82.1448 60.3177 85.6614L60.3211 85.6614ZM60.3211 85.6614L74.4997 85.4942M74.4997 85.4942L74.4997 93.5002"
                stroke={stroke || '#0F90FF'}
                strokeWidth="5"
                strokeMiterlimit="10"
                strokeLinecap="round"
            />
        </svg>
  );
};

export default TokenIcon;
